import { cn } from '@lib/utils';

interface DescriptionProps {
  description: React.ReactNode;
  className?: string;
}

function Description({ description, className }: DescriptionProps) {
  const baseClassName =
    'text-[#2B2E33] text-sm font-medium leading-22 tracking-[-0.128px] md:text-base md:font-medium md:leading-26 md:tracking-[-0.176px]';

  return <p className={cn(baseClassName, className)}>{description}</p>;
}

export default Description;
